module.exports = __webpack_public_path__ + "static/media/etronkz.8fea5351.pdf";